import React, { useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useEffect } from "react";
import { useCaptureEvent } from "../../../hooks/useCaptureEvent";
import { setPreferences } from "../../../apis/ext";
import { Button } from "../../ui/button";
import Image from "../../Tags/Image";
import { setWorkspacePreferences } from "../../../apis/crm";
import { enableConfig } from "../../../apis/workspace/integrations";
import toast from "react-hot-toast";
import { useIntegrations } from "../../../apiHooks/useIntegrations";

export default function Intro({ installedCrm, activeWorkspace, activeCrm, enabledCRMIntegrations = [] }) {
  const { refetch: refetchIntegrations } = useIntegrations(activeWorkspace?.id);
  const captureEvent = useCaptureEvent();
  const queryClient = useQueryClient();
  const [activeCrmId, setActiveCrmId] = useState(activeCrm);
  const setPreferencesFn = useMutation("set_pref", setWorkspacePreferences, {
    onSuccess(data, variables, context) {
      toast.success("CRM activated.");
      queryClient.invalidateQueries("get_user");
      refetchIntegrations();
    },
    onError(error) {
      console.log(error);
    },
  });

  const enableConfigFn = useMutation("enable_config", enableConfig, {
    onSuccess(data, variables, context) {
      refetchIntegrations();
      handleSetPreferences(activeCrmId);
    },
  });

  const handleEnableCRM = (id) => {
    if (enableConfigFn.isLoading) {
      return;
    }
    enableConfigFn.mutate({
      id: id,
      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    });
  };

  const handleEnableCRMandSetPref = (value) => {
    if (!enabledCRMIntegrations?.find((el) => el.id === value)) {
      handleEnableCRM(value);
    } else {
      handleSetPreferences(value);
    }
  };

  const handleSetPreferences = (value) => {
    if (setPreferencesFn.isLoading) {
      return;
    } else {
      setPreferencesFn.mutate({
        data: {
          preferences: {
            active_crm_workspace_integration_config_id: value,
          },
        },
        options: {
          headers: { "X-Workspace-Id": activeWorkspace?.id },
        },
      });
    }
  };

  useEffect(() => {
    if (installedCrm && installedCrm.length > 0) {
      setActiveCrmId(installedCrm[0]?.id);
    }
  }, [installedCrm]);

  if (!activeCrm && installedCrm && installedCrm.length > 1) {
    return (
      <div className="">
        <div>
          <p className="text-sm mb-2 text-gray-600">
            There are multiple CRM integrations found. <br /> Please select one to continue.
          </p>

          <div className="space-y-2">
            {activeWorkspace.role === "Admin" || activeWorkspace.role === "Owner" ? (
              <>
                <select
                  defaultValue={activeCrm ? activeCrm : installedCrm[0].id}
                  // value={activeCrm ? activeCrm : installedCrm[0].id}
                  onChange={(e) => {
                    console.log("activeCrmIdChange", e.target.value);
                    setActiveCrmId(e.target.value);
                  }}
                  className="h-9 w-full bg-background rounded-md border border-input bg-transparent px-2 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                >
                  {installedCrm.map((item, index) => (
                    <option value={item.id} selected={index === 0}>
                      {item.name}
                    </option>
                  ))}
                </select>
                <Button
                  disabled={setPreferencesFn.isLoading || enableConfigFn.isLoading}
                  variant="purple"
                  onClick={() => {
                    console.log("activeCrmId", activeCrmId);
                    handleEnableCRMandSetPref(activeCrmId);
                  }}
                  className="w-full"
                >
                  Submit{" "}
                  {(setPreferencesFn.isLoading || enableConfigFn.isLoading) && (
                    <div className="loader_circle inline-block ml-2"></div>
                  )}
                </Button>
              </>
            ) : (
              <>
                <select
                  defaultValue={activeCrm ? activeCrm : installedCrm[0].id}
                  // value={activeCrm ? activeCrm : installedCrm[0].id}
                  onChange={(e) => {
                    setActiveCrmId(e.target.value);
                  }}
                  className="h-9 w-full bg-background rounded-md border border-input bg-transparent px-2 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                >
                  {installedCrm.map((item, index) => (
                    <option value={item.id} selected={index === 0}>
                      {item.name}
                    </option>
                  ))}
                </select>
                <p className="text-warning-600">Please ask your admin to enable CRM.</p>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="">
      <div className="flex justify-center items-center">
        {/* {installedCrm && installedCrm.length > 0 && <Image src="/images/ext/crm/crm.svg" className="m-3 no-invert" />} */}

        {/* <Image className="no-invert" src="/images/ext/crm/hubspot.svg" /> */}
      </div>
      <h3 className="text-sm font-bold text-gray-900 text-center mt-2">Integrate your CRM</h3>
      <p className="text-gray-600 text-sm mt-3 text-center mb-4">
        With CRM integration, you can check if companies and people exist in your CRM and create/update
        records directly from {process.env.REACT_APP_APP_NAME} extension.
      </p>
      {activeWorkspace.role === "Admin" || activeWorkspace.role === "Owner" ? (
        <a
          href={`${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_APP_HOME}/${activeWorkspace?.slug}/settings/integrations?tab=integrations&category=CRM`}
          target="_blank"
          className="flex w-full justify-center items-center whitespace-nowrap text-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 border bg-background border-brand-300 text-brand-700 px-4 py-2 h-9 rounded-[8px] font-semibold"
          onClick={() => {
            captureEvent("EXP_IntegrateCRMBtn");
          }}
        >
          Integrate CRM
        </a>
      ) : (
        <p className="text-warning-600">Please ask your admin to integrate CRM.</p>
      )}
    </div>
  );
}
